import { getBetslipById } from '#src/services/bettingAcceptanceService'
import { ref } from 'vue'
import type { BetslipView } from '@nsftx/seven-client-sdk-integrator'
import bettingAcceptanceErrorParser from '#src/utils/bettingAcceptanceErrorParser'

const betslip = ref<BetslipView | null>(null)

export const useFetchBetslip = () => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)
  const errorDetails = ref<ReturnType<typeof bettingAcceptanceErrorParser.parse> | null>(null)

  const fetchBetslip = (id: string) => {
    isLoading.value = true
    error.value = null
    betslip.value = null

    return getBetslipById(id)
      .then((result) => {
        betslip.value = result.data
      })
      .catch((err) => {
        error.value = err
        errorDetails.value = bettingAcceptanceErrorParser.parse(err)
      })
      .finally(() => {
        isLoading.value = false
      })
  }

  return {
    fetchBetslip,
    betslip,
    isLoading,
    error,
    errorDetails
  }
}
